export const COMPREHENSION_DRILLS = [
    {
        id: 'joke1',
        text: 'WHY DID THE CHICKEN CROSS THE ROAD? TO GET TO THE OTHER SIDE.',
        question: 'Why did the chicken cross?',
        options: ['TO EAT', 'TO SLEEP', 'TO GET TO THE OTHER SIDE', 'TO RUN AWAY'],
        answer: 'TO GET TO THE OTHER SIDE',
        difficulty: 'Easy'
    },
    {
        id: 'story1',
        text: 'THE RED CAR DROVE FAST DOWN THE HIGHWAY. IT PASSED A BLUE TRUCK.',
        question: 'What color was the truck?',
        options: ['RED', 'BLUE', 'GREEN', 'BLACK'],
        answer: 'BLUE',
        difficulty: 'Easy'
    },
    {
        id: 'wx1',
        text: 'WEATHER REPORT. SUNNY SKIES WITH A HIGH OF 75 DEGREES. WIND NORTH 10 KNOTS.',
        question: 'What is the wind direction?',
        options: ['SOUTH', 'EAST', 'WEST', 'NORTH'],
        answer: 'NORTH',
        difficulty: 'Medium'
    },
    {
        id: 'story2',
        text: 'ALICE HAS THREE CATS AND TWO DOGS. HER FAVORITE CAT IS NAMED LUNA.',
        question: 'What is the name of the favorite cat?',
        options: ['ALICE', 'LUNA', 'SPOT', 'KITTY'],
        answer: 'LUNA',
        difficulty: 'Easy'
    },
    {
        id: 'qso1',
        text: 'CQ CQ CQ DE K1ABC K1ABC. UR 599 599 CT CT BK.',
        question: 'What is the signal report?',
        options: ['559', '579', '599', '59'],
        answer: '599',
        difficulty: 'Medium'
    },
    {
        id: 'news1',
        text: 'BREAKING NEWS. LOCAL MAN WINS PIE EATING CONTEST. ATE FIFTY PIES IN TEN MINUTES.',
        question: 'How many pies were eaten?',
        options: ['FIVE', 'FIFTEEN', 'FIFTY', 'TEN'],
        answer: 'FIFTY',
        difficulty: 'Medium'
    },
    {
        id: 'joke2',
        text: 'WHAT DO YOU CALL A FAKE NOODLE? AN IMPASTA.',
        question: 'What is a fake noodle called?',
        options: ['PASTA', 'NOODLE', 'IMPASTA', 'FAKE'],
        answer: 'IMPASTA',
        difficulty: 'Easy'
    }
];
